// extracted by mini-css-extract-plugin
module.exports = {"v-icon":"NsAddressRu_v-icon_2sRHO","nsAddressForm":"NsAddressRu_nsAddressForm_2AQFL","dualColumn":"NsAddressRu_dualColumn_2R-ez","firstCol":"NsAddressRu_firstCol_3yqPz"};